import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { SendRounded } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AIChatWindowChatMessageBoxInputView = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      sendMessage = props.sendMessage,
      loading = props.loading;

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useState2 = useState(false),
      inputSendLoading = _useState2[0],
      setInputSendLoading = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    setInputSendLoading(loading);
  }, [loading]);
  /**
   * methods
   */

  var inputValueChangeAction = function inputValueChangeAction(e) {
    setInputValue(e.target.value);
  };

  var handleInputKeyDown = function handleInputKeyDown(event) {
    if (event.key !== 'Enter' || event.shiftKey) {
      return;
    }

    event.preventDefault();
    sendMessageAction();
  };

  var sendMessageAction = function sendMessageAction() {
    var inputMessage = inputValue.trim();

    if (!inputMessage) {
      return;
    }

    sendMessage === null || sendMessage === void 0 ? void 0 : sendMessage({
      message: inputMessage
    });
  };
  /**
   * external methods
   */


  useImperativeHandle(ref, function () {
    return {
      cleanInputInfo: cleanInputInfo
    };
  });

  var cleanInputInfo = function cleanInputInfo() {
    setInputValue('');
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('border-t border-[#E5E7EB] bg-white px-4 py-3', className),
    children: /*#__PURE__*/_jsxs(Box, {
      className: "flex items-end gap-3 rounded-xl border border-[#D1D5DB] bg-white px-2 py-1 shadow-sm transition-colors",
      children: [/*#__PURE__*/_jsx("textarea", {
        value: inputValue,
        onChange: inputValueChangeAction,
        onKeyDown: handleInputKeyDown,
        rows: 1,
        placeholder: "Type your message...",
        className: "max-h-32 min-h-[24px] flex-1 resize-none border-0 bg-transparent text-sm leading-6 text-[#111827] outline-none placeholder:text-[#9CA3AF] focus:outline-none focus:ring-0 focus-visible:outline-none"
      }), /*#__PURE__*/_jsx(IconButton, {
        color: "primary",
        onClick: sendMessageAction,
        disabled: !inputValue || inputSendLoading,
        className: "self-end",
        "aria-label": "Send message",
        children: /*#__PURE__*/_jsx(SendRounded, {
          fontSize: "small"
        })
      })]
    })
  });
});
export default AIChatWindowChatMessageBoxInputView;